import { render, staticRenderFns } from "./SelectPlacement.vue?vue&type=template&id=ffd318d8"
import script from "./SelectPlacement.vue?vue&type=script&lang=ts"
export * from "./SelectPlacement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffd318d8')) {
      api.createRecord('ffd318d8', component.options)
    } else {
      api.reload('ffd318d8', component.options)
    }
    module.hot.accept("./SelectPlacement.vue?vue&type=template&id=ffd318d8", function () {
      api.rerender('ffd318d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/SelectPlacement.vue"
export default component.exports